// extracted by mini-css-extract-plugin
export var company = "styles-module--company--089a4";
export var companyName = "styles-module--companyName--1b197";
export var hiddenScrollbar = "styles-module--hiddenScrollbar--e6c21";
export var linkButton = "styles-module--linkButton--41b5e";
export var logo = "styles-module--logo--5e6af";
export var logoRow = "styles-module--logoRow--7264d";
export var opened = "styles-module--opened--7d87b";
export var section = "styles-module--section--77c3c";
export var sectionHeading = "styles-module--sectionHeading--a769b";
export var sections = "styles-module--sections--0887c";
export var subSection = "styles-module--subSection--6022a";
export var subSectionLink = "styles-module--subSectionLink--35cc4";
export var subSectionLinkImage = "styles-module--subSectionLinkImage--961fb";
export var subSectionLinkTitle = "styles-module--subSectionLinkTitle--1d3ab";
export var subSections = "styles-module--subSections--1c7b5";
export var toggleButton = "styles-module--toggleButton--22f06";
export var wrapper = "styles-module--wrapper--18a70";